export const MessageActionTypes = {
  SET_MESSAGE: 'SET_MESSAGE',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
  SET_MESSAGE_TYPE: 'SET_MESSAGE_TYPE',
  SET_MESSAGE_SUBJECT: 'SET_MESSAGE_SUBJECT',
  SET_MESSAGE_HTML: 'SET_MESSAGE_HTML',
  SET_MESSAGE_TEMPLATE_ID: 'SET_MESSAGE_TEMPLATE_ID',
  SET_MESSAGE_DATA: 'SET_MESSAGE_DATA',

  SEND_EMAIL_START: 'SEND_EMAIL_START',
  SEND_EMAIL_SUCCESS: 'SEND_EMAIL_SUCCESS',
  SEND_EMAIL_FAILURE: 'SEND_EMAIL_FAILURE',

  SEND_TEXT_START: 'SEND_TEXT_START',
  SEND_TEXT_SUCCESS: 'SEND_TEXT_SUCCESS',
  SEND_TEXT_FAILURE: 'SEND_TEXT_FAILURE',
};
